import React, { useContext } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import * as Sentry from '@sentry/react';

import { ThemeProvider } from '@mui/material';
import {
  Login,
  JoinInterpreter,
  ThankYou,
  LoginSelectorPage,
} from '../../pages';
import { ThemeMode } from 'utils/contexts/theme-mode.context';
import PrivateLayout from 'shared/components/layout/private-layout.component';
import PublicLayout from 'shared/components/layout/public-layout.component';
import RequestLocation from 'pages/LocationSelector/location-select.component';
import { MeetingStatusContextProvider } from 'utils/contexts/meeting-status-context';

export default function AppRouter() {
  const { theme } = useContext(ThemeMode);
  const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);

  return (
    <BrowserRouter basename='proxy/zoomapp'>
      <ThemeProvider theme={theme}>
        <MeetingStatusContextProvider>
          <SentryRoutes>
            <Route path='/' element={<PrivateLayout />}>
              <Route index element={<JoinInterpreter />} />
              <Route path='/thankyou' element={<ThankYou />} />
              <Route path='/location' element={<RequestLocation />} />
            </Route>
            <Route path='/login' element={<PublicLayout />}>
              <Route index element={<LoginSelectorPage />} />
              <Route path='vrs' element={<Login />} />
            </Route>
            <Route path='*' element={<Navigate to='/' />} />
          </SentryRoutes>
        </MeetingStatusContextProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}
